(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/shared/game-analysis-filter-utils.js') >= 0) return;  svs.modules.push('/components/content/shared/game-analysis-filter-utils.js'); "use strict";

var validTypes = ['cnt:authorProfile', 'cnt:drawAnalysis', 'cnt:gameAnalysis'];
var excludedRootVariables = ['properties', 'parentId', 'parentName', 'rank', 'version'];
var excludedAuthorProfileVariables = [].concat(excludedRootVariables);
var excludedGameAnalysisVariables = [].concat(excludedRootVariables);
var rootRenamePairs = [{
  from: 'domainCategories',
  to: 'gameInfo'
}];
var authorProfileRenamePairs = [{
  from: 'domainCategories',
  to: 'authorInfo'
}];
var gameAnalysisRenamePairs = [{
  from: 'domainCategories',
  to: 'gameAnalysisInfo'
}];

var typeIsValid = function typeIsValid(result) {
  return result ? validTypes.indexOf(result.contentType) > -1 : result;
};


var deepCopyOf = function deepCopyOf(obj) {
  return obj ? JSON.parse(JSON.stringify(obj)) : obj;
};


var excludeVariableIn = function excludeVariableIn(section, variableName) {
  if (section) {
    var copyOfSection = deepCopyOf(section);
    delete copyOfSection[variableName];
    return copyOfSection;
  }
};


var renameVariableIn = function renameVariableIn(json, renamePair) {
  if (json) {
    var jsonStringSplit = JSON.stringify(json).split(renamePair.from);

    var hasVariable = function hasVariable(stringSplit) {
      return stringSplit.length !== 1 || stringSplit[0] !== '';
    };

    return hasVariable(jsonStringSplit) ? JSON.parse(jsonStringSplit.join(renamePair.to)) : null;
  }
};


var kebabToCamel = function kebabToCamel(inString) {
  return inString.replace(/([-_][a-z])/g, function (matches) {
    return matches.toUpperCase().replace('-', '').replace('_', '');
  });
};


var processDomainCategoriesFrom = function processDomainCategoriesFrom(domainCategories) {
  if (Array.isArray(domainCategories)) {
    var copyOfDomainCategories = deepCopyOf(domainCategories);
    var processedDomainCategories = {};
    copyOfDomainCategories.forEach(function (domainCategory) {
      var value = domainCategory.split('/')[1];
      var keyName = kebabToCamel(domainCategory.split('svs-domain-')[1].split('/')[0]);

      if (Array.isArray(processedDomainCategories[keyName])) {
        processedDomainCategories[keyName].push(value);
      } else {
        processedDomainCategories[keyName] = [value];
      }
    });
    return processedDomainCategories;
  }

  return domainCategories;
};


var processAuthorProfileFrom = function processAuthorProfileFrom(authorProfile) {
  authorProfile.domainCategories = processDomainCategoriesFrom(authorProfile.domainCategories);
  excludedAuthorProfileVariables.forEach(function (excludedVariable) {
    authorProfile = excludeVariableIn(authorProfile, excludedVariable);
  });
  return authorProfile;
};


var processGameAnalysesFrom = function processGameAnalysesFrom(gameAnalyses) {
  if (gameAnalyses) {
    var processedGameAnalyses = [];
    gameAnalyses.forEach(function (gameAnalysis) {
      gameAnalysis.domainCategories = processDomainCategoriesFrom(gameAnalysis.domainCategories);
      gameAnalysis.eventNumber = gameAnalysis.properties.cnt_eventNumber;
      gameAnalysis.gamePredictions = JSON.parse(gameAnalysis.properties.cnt_gamePrediction);
      excludedGameAnalysisVariables.forEach(function (excludedVariable) {
        gameAnalysis = excludeVariableIn(gameAnalysis, excludedVariable);
      });
      processedGameAnalyses.push(gameAnalysis);
    });
    return processedGameAnalyses;
  }
};


var processRenamingOn = function processRenamingOn(result) {
  authorProfileRenamePairs.forEach(function (renamePair) {
    result.authorProfile = renameVariableIn(result.authorProfile, renamePair);
  });
  gameAnalysisRenamePairs.forEach(function (renamePair) {
    result.gameAnalysis = renameVariableIn(result.gameAnalysis, renamePair);
  });
  rootRenamePairs.forEach(function (renamePair) {
    result = renameVariableIn(result, renamePair);
  });
  return result;
};

var exportPayload = {
  deepCopyOf: deepCopyOf,
  typeIsValid: typeIsValid,
  processAuthorProfileFrom: processAuthorProfileFrom,
  processGameAnalysesFrom: processGameAnalysesFrom,
  processDomainCategoriesFrom: processDomainCategoriesFrom,
  excludeVariableIn: excludeVariableIn,
  excludedRootVariables: excludedRootVariables,
  processRenamingOn: processRenamingOn,
  validTypes: validTypes
};

if (svs.isServer) {
  module.exports = exportPayload;
} else {
  svs.content.shared.filters.gameAnalysisFilter.gameAnalysisFilterUtils = exportPayload;
}
 })(window);